import { Box } from '@mui/material'
import { PageHeader } from '../components/shared/PageHeader'
import { MarketingPage as MarketingComponent } from '../features/marketing/MarketingPage'

export default function MarketingPageWrapper() {
  return (
    <Box>
      <PageHeader title="Marketing" />
      <MarketingComponent />
    </Box>
  )
}
